import React from "react";
import IEPappStructure from "./img/iep-app-diagram";
import ThumbCVS from "./img/iep-thumb-cvs.jpg";

function IEPCardStructure() {
	return (
		<section className="card-iep-structure">
			<h2 className="title">Understanding the product</h2>
			<div className="content-row">
				<figure className="diagram">
					<IEPappStructure />
				</figure>
				<article className="content">
					<p>
						Prior to my start, the teams had been focusing on the 'ingestion' of
						millions of sensitive health records, analytics, and administrative
						data. This data was being migrated from{" "}
						<a
							className="link-inline"
							href="https://www.cvs.com/content/scriptsync"
							target="_blank"
							rel="noopener noreferrer"
						>
							CVS
						</a>{" "}
						and{" "}
						<a
							className="link-inline"
							href="https://www.forbes.com/sites/brucejapsen/2019/01/30/anthem-will-launch-new-pbm-earlier-than-expected/#f58e39613203"
							target="_blank"
							rel="noopener noreferrer"
						>
							Express Scripts
						</a>{" "}
						PMB services.
					</p>
					<p>
						The initial user-base would be internal administrative staff, but
						this would grow to include partner companies with role-based access.
						In essence, the interface would have to serve the needs of
						power-users who had specialised knowledge and requirements.
					</p>
					<p>
						Any UX / UI work had yet to be started. A few core concepts, such as
						the relational hierarchy, had to be incorporated in the UI. This
						hierarchy connected providers, groups and members in a{" "}
						<strong>one-to-many</strong> algorithm. For example, a Client can
						have many Carriers, but a Carrier could only be connected to a
						single Client.
					</p>
				</article>
				<figure className="thumb">
					<img src={ThumbCVS} alt="CVS Pharmacy checkout counter" />
				</figure>
			</div>
		</section>
	);
}

export default IEPCardStructure;
